export const getOpacity = (hex: string, alpha: number) => {
  const _opacity = Math.round(Math.min(Math.max(alpha ?? 1, 0), 1) * 255)
  return hex + _opacity.toString(16).padStart(2, '0')
}
